<template>
  <div id="active-plans">
    <b-row class="mt-4" v-if="loadingData && !loadError">
      <b-col
        v-for="(item, index) in 3"
        cols="12"
        md="6"
        lg="4"
        :key="item + index"
        class="mb-4"
      >
        <b-progress
          variant="primary"
          :max="100"
          class="w-100"
          show-progress
          animated
          height="200px"
        >
          <b-progress-bar :value="100">Loading...</b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <b-row v-else-if="loadError" class="mt-4" align-v="stretch">
      <b-col cols="12" class="mb-4">
        <div class="text-center" title="Could not load, click on retry">
          <b-button
            size="sm"
            @click="loadInvestments()"
            variant="light"
            class="w-100"
            style="height:200px"
          >
            <bad-network-icon />
            <br />Error Loading Data, <br />click to retry
            <reload-icon class="ml-1" />
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- <b-row v-else class="mt-4 "   align align-v="stretch">
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-4"
        v-for="(subscription, index) in subscriptions"
        :key="subscription.amount + index"
      >
        <div
          variant="white"
          class="w-100 wrapper h-100  bg-white dash-card investment-blocks text-left p-0"
        >
          <div
            class="upper mb-1 bg-light p-4 text-white shadow-2xl"
            :style="{
              backgroundImage:
                ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` +
                farm_img +
                `)`
            }"
          >
            <b-row align-h="between">
              <b-col cols="auto">
                <h5 class="text-white">
                  {{ subscription.location.locationname }} Farm<br />
                  <div style="font-size:15px; text-transform:capitalize">
                    {{ subscription.units }} units
                  </div>
                </h5>
              </b-col>
            </b-row>
          </div>
          <div class="upper p-4">
            <h4 class="mb-0">
              <Money class="text-primary" :value="subscription.location.amount || 0" />
            </h4>
            <small class="d-investment text-dark">
            </small>
            <hr class="mt-3" />
            <b-row align-h="between">
              <b-col>
                <b-button
                  variant="light"
                  @click="handleDetails(subscription)"
                  class="w-100 btn-sm"
                  >Details</b-button
                >
              </b-col>
              <b-col>
                <b-button
                  variant="primary"
                  @click="handleInvest(subscription)"
                  class="w-100 btn-sm"
                  >Farm For Me</b-button
                >
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>


    </b-row> -->

    <b-row class="mt-4" align align-v="stretch" v-if="subscriptions.length > 0">
      <b-col
        class="mb-5 mr-20"
        cols="12"
        md="6"
        lg="6"
        xl="4"
        v-for="(plannedSubscription, index) in subscriptions"
        :key="plannedSubscription + index"
      >
        <router-link
          class=""
          :to="`${routePath + plannedSubscription.id}`"
          ><div class="wrap dash-card bg-white position-relative card-shadow action-btn">
            <div class="wrap p-0 mt-2">
              <div
                class="dash-card bg-dark shadow-xl text-white"
                style=" padding:30px 20px; margin-bottom:10px"
                :style="{
                  backgroundImage:
                    ` linear-gradient(0deg, rgba(0,0,0,40), transparent), url(` +
                    farm_img +
                    `)`,
                }"
              >
                <b-row no-gutters>
                  <b-col cols="12">
                    <div class="d-flex justify-content-between align-items-end">
                      <div>
                        <i class="fas fa-tractor text-white"></i><br />
                        <h5 class="mb-2 mt-1 mr-2">
                          {{ plannedSubscription.location.locationname }} Farm
                        </h5>
                        <p class="d-inline-block mb-0 mr-2">
                          {{ plannedSubscription.units }} unit{{
                            plannedSubscription.units === 1 ? "" : "s"
                          }}
                        </p>
                      </div>
                      <div></div>
                    </div>

                    <hr class="mt-0" />
                    <div class="d-flex justify-content-between">
                      <p class="mb-0">
                        {{ plannedSubscription.plotsplanted }} unit{{
                          plannedSubscription.plotsplanted === 1 ? "" : "s"
                        }}
                        in use
                      </p>
                    </div>
                    <b-progress
                      :value="plannedSubscription.plotsplanted"
                      :max="plannedSubscription.units"
                      class="mb-3 w-85"
                      variant="primary"
                      style="height: 5px "
                    ></b-progress>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </router-link>
      </b-col>
    </b-row>

    <div></div>
    <b-row v-if="subscriptions.length == 0 && !loadingData && !loadingError">
      <b-col cols="12">
        <div
          class="d-flex bg-white dash-card p-5 align-items-center justify-content-center"
          style="height:200px"
        >
          <div class="wrap text-center">
            <h5>You haven't bought any farm yet</h5>
            <h5 v-if="requests.length > 0">
              Your farm ownership request is still awaiting approval.
            </h5>
            <b-button variant="primary" @click="$emit('setInvestTab')"
              >Own a farm</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <FarmPackagePayment v-if="activeRequest.id!=undefined" :request="activeRequest" /> -->
  </div>
</template>

<script>
// @ts-nocheck
import { DateTime as LuxonDateTime } from "luxon";
import { UserService } from "@/services";
import { formatMoney } from "@/utils/helpers";
import loadData from "@/mixins/loadData";
// import FarmPackagePayment from "./FarmPackagePayment";

export default {
  data() {
    return {
      loadingData: true,
      loadingError: true,
      value: "70",
      display: false,
      subscriptions: [],
      activeRequest: {},
      requests: {},
      plannedSubscriptions: [],
      LuxonDateTime: LuxonDateTime,
      routePath: "farms/ownership/",
      farm_img: "https://agbeloba-media.s3.amazonaws.com/cassava.jpg",
      ativePlans: [
        {
          farmname: "Atan",
          value: 50,
          plots: "30",
          farm_img: "https://agbeloba-media.s3.amazonaws.com/cassava.jpg",
        },
        {
          farmname: "ibadan",
          value: 80,
          plots: "10",
          farm_img: "https://agbeloba-media.s3.amazonaws.com/cassava.jpg",
        },
        {
          farmname: "abeokuta",
          value: 20,
          plots: "70",
          farm_img: "https://agbeloba-media.s3.amazonaws.com/cassava.jpg",
        },
      ],
    };
  },
  mixins: [loadData],
  methods: {
    formatMoney,
    async loadInvestments() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await UserService.getFarmSubscriptions();
        let subscriptions = data.data.subscriptions;

        // if (subscriptions.length == 0) {
        //   this.loadFarmRequests();
        // }

        this.subscriptions = [];
        // this.calcFarmlandUsage(subscriptions)

        subscriptions.forEach((sub) => {
          // if (sub.package.type == "sale") {
          this.subscriptions.push(sub);
          // }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },

    // calcFarmlandUsage(data){
    //   let usage = 0
    //   data.forEach(elm =>{
    //     if(elm.farmmanagements.length > 0){

    //     }

    //     return usage
    //   })
    // },

    async loadFarmRequests() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await UserService.getFarmRequests();
        let requests = data.requests;

        this.requests = [];

        requests.forEach((request) => {
          // if (request.package.type == "sale") {
          this.requests.push(request);
          // }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
  },
  mounted() {
    this.loadInvestments();
  },
};
</script>

<style>
.action-btn {
    -webkit-box-shadow: 0 20px 25px -5px rgba(0,0,0,.1), 0 10px 10px -5px rgba(0,0,0,.04);
    box-shadow: 0 20px 25px -5px rgba(0,0,0,.1), 0 10px 10px -5px rgba(0,0,0,.04);
    border-radius: 10px;
}

.action-btn:hover {
    -webkit-box-shadow: 0 5px 5px -5px rgba(0,0,0,.1), 0 5px 5px -5px rgba(0,0,0,.04);
    box-shadow: 0 5px 5px -5px rgba(0,0,0,.1), 0 5px 5px -5px rgba(0,0,0,.04);
    -webkit-transition: all .3s ease;
    transition: all .1s ease;
    border-radius: 10px;
}
.upper {
  background-size: cover;
  border-radius: 5px 5px 0 0;
}

.wrap small {
  font-size: 12px;
  font-weight: 700;
}

.wrap .d-block {
  font-size: 15px;
  font-weight: 700;
}

h6 {
  text-transform: capitalize;
}
.Farmplan-btn {
  color: #fff;
}

.card-shadow {
  /* border-radius: 30px; */
  box-shadow: -2px 10px 40px rgb(180, 180, 180);
}

.card-shadow i {
  font-size: 30px;
  padding: 10px;
}

.location-price {
  font-size: 20px;
  color: rgb(1, 148, 14);
}

.location-unit {
  font-size: 13px;
  float: right;
  margin-top: 4px;
}
.font-small {
  font-size: 14px;
  /* color: rgb(207, 13, 13) */
}

.plan-cards img {
  /* width: 400px; */
  height: 220px;
  /* background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), transparent), */
}
</style>
